import {put, takeLatest} from 'redux-saga/effects'
import {REQUEST_API} from "./constants";
import {getError, getResponseAPI} from "./actions";

export default function* watchAppSaga() {
  yield takeLatest(REQUEST_API, _request_API);
}

function* _request_API(action) {
  let error;
  const responses = yield Promise.all(action.data.urls.map(async url => {
    let data;
    try {
      const response = await fetch(`${process.env.REACT_APP_DEFAULT_PROTOCOL}${action.data.user.hostname || process.env.REACT_APP_DEFAULT_USER_HOSTNAME}/v1.1/?url=${encodeURIComponent(url)}&apikey=${action.data.apikey}`);
      data = await response.json();
      if (data.quota_exceeded) {
        error = "Please register an account to check continue";
      }else{
        return {url, data};
      }
      
    } catch (e) {
      data = {
        Facebook: {
          comment_plugin_count: 0,
          total_count: 0,
          og_object: null,
          comment_count: 0,
          share_count: 0,
          reaction_count: 0,
        },
        Pinterest: 0
      };
    }
     return {url,data};
  }));
  if (error) {
    yield put(getError(error));
  } else {
    yield put(getResponseAPI(responses));
  }
}

